import { render, staticRenderFns } from "./login-footer.vue?vue&type=template&id=22c0cef1&scoped=true&"
import script from "./login-footer.vue?vue&type=script&lang=js&"
export * from "./login-footer.vue?vue&type=script&lang=js&"
import style0 from "./login-footer.vue?vue&type=style&index=0&id=22c0cef1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c0cef1",
  null
  
)

export default component.exports